<!-- eslint-disable vue/no-v-html -->
<template>
  <transition
    :name="device.isAtLeastMd ? 'slide-from-right' : 'slide-from-top'"
  >
    <template v-if="toast.config">
      <div
        class="Toast fixed z-50 py-3 sm<:m-2 sm<:rounded-lg md:right-0 md:rounded-l-lg md:mt-8 md:max-w-xl will-change-transform"
        :class="[colorsCls, mobileMarginTop]"
      >
        <div class="flex gap-2 px-4 items-start">
          <div class="w-8 pt-0.5">
            <StellaIcon :icon="iconId" />
          </div>
          <div class="flex flex-col gap-1 mr-4">
            <StellaText type="Label S" v-if="toast.config.title">
              {{ toast.config.title }}
            </StellaText>
            <StellaText type="Body S">
              {{ toast.config.message }}
            </StellaText>
          </div>

          <StellaLink
            v-if="toast.config.action?.type === 'link'"
            text="Action"
            size="XS"
            :to="toast.config.action.link"
            class="-mt-1 pl-6"
            :class="[colorsCls]"
          />
          <StellaText
            v-else-if="toast.config.action?.type === 'button'"
            type="Link XS"
            class="cursor-pointer"
            @click="buttonActionHandler"
          >
            {{ toast.config.action.label ?? 'Action' }}
          </StellaText>

          <div class="w-8">
            <StellaIcon
              class="cursor-pointer mt-0.5"
              icon="x"
              size="xs"
              @click="toast.hide"
            />
          </div>
        </div>
      </div>
    </template>
  </transition>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useToast } from '.'
import { type StellaIconId } from '/@/stella/icons/types'
import { device } from '/@/utils/responsive'
import { useNavHeight } from '/@/stella/StellaNavBar'

const toast = useToast()
const navHeight = useNavHeight()

const mobileMarginTop = computed(() => {
  switch (navHeight.displayType.value) {
    case 'default':
      return 'sm<:top-[30px]'
    case 'default with top':
      return 'sm<:top-[70px]'
    case 'tall':
      return 'sm<:top-[60px]'
    case 'tall with top':
      return 'sm<:top-[100px]'
  }
  return ''
})

const colorsCls = computed(() => {
  switch (toast.config?.severity) {
    case 'critical':
      return 'bg-red-10 text-red-80'
    case 'warning':
      return 'bg-yellow-10 text-yellow-80'
    case 'success':
      return 'bg-green-10 text-green-80'
    case 'info':
    default:
      return 'bg-purple-10 text-purple-80'
  }
})
const iconId = computed<StellaIconId>(() => {
  if (toast.config?.icon) {
    return toast.config.icon
  }

  switch (toast.config?.severity) {
    case 'critical':
    case 'warning':
      return 'exclamationmark-triangle'
    case 'success':
      return 'check-circle'
    case 'info':
    default:
      return 'info-circle'
  }
})

function buttonActionHandler() {
  if (toast.config?.action?.type === 'button') {
    toast.config.action.handler()
    toast.hide()
  }
}
</script>

<style lang="scss" scoped>
.slide-from-right {
  &-enter-active,
  &-leave-active {
    transition: transform 100ms ease-in-out;
  }
  &-enter-from,
  &-leave-to {
    transform: translateX(120%);
  }
}
.slide-from-top {
  &-enter-active,
  &-leave-active {
    transition: transform 100ms ease-in-out;
  }
  &-enter-from,
  &-leave-to {
    transform: translateY(-220%);
  }
}
</style>
